/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { EmailTemplateDtoModel, EmailTemplateDtoModelType } from "./EmailTemplateDtoModel"
import { EmailTemplateDtoModelSelector } from "./EmailTemplateDtoModel.base"
import { SmsTemplateDtoModel, SmsTemplateDtoModelType } from "./SmsTemplateDtoModel"
import { SmsTemplateDtoModelSelector } from "./SmsTemplateDtoModel.base"
import { RootStoreType } from "./index"


/**
 * NotificationTypeSettingsDtoBase
 * auto generated base class for the model NotificationTypeSettingsDtoModel.
 */
export const NotificationTypeSettingsDtoModelBase = ModelBase
  .named('NotificationTypeSettingsDto')
  .props({
    __typename: types.optional(types.literal("NotificationTypeSettingsDto"), "NotificationTypeSettingsDto"),
    enabled: types.union(types.undefined, types.boolean),
    emailTemplate: types.union(types.undefined, types.late((): any => EmailTemplateDtoModel)),
    smsTemplate: types.union(types.undefined, types.late((): any => SmsTemplateDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class NotificationTypeSettingsDtoModelSelector extends QueryBuilder {
  get enabled() { return this.__attr(`enabled`) }
  emailTemplate(builder: string | EmailTemplateDtoModelSelector | ((selector: EmailTemplateDtoModelSelector) => EmailTemplateDtoModelSelector) | undefined) { return this.__child(`emailTemplate`, EmailTemplateDtoModelSelector, builder) }
  smsTemplate(builder: string | SmsTemplateDtoModelSelector | ((selector: SmsTemplateDtoModelSelector) => SmsTemplateDtoModelSelector) | undefined) { return this.__child(`smsTemplate`, SmsTemplateDtoModelSelector, builder) }
}
export function selectFromNotificationTypeSettingsDto() {
  return new NotificationTypeSettingsDtoModelSelector()
}

export const notificationTypeSettingsDtoModelPrimitives = selectFromNotificationTypeSettingsDto().enabled
